export default "__VITE_ASSET__CSd4yhTn__"